import { render, staticRenderFns } from "./SignatureDialog.vue?vue&type=template&id=16fb3e54"
import script from "./SignatureDialog.vue?vue&type=script&lang=ts"
export * from "./SignatureDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports